// This file is generated by scripts/prepublish.mjs
// Do not edit this file directly
// This file relies on a loader to turn this `require` into a URL
module.exports = require('./../../static/microbit/scratch-microbit-1.1.0.hex');
